<template>
    <div class="print-page" v-if="data && user">
        <h2>{{ data.title }}</h2>
        <br/>
        <br/>
        <div class="d-flex justify-center">
            <h3>编号</h3>
            <input class="squ ml-ns" type="text" readonly :value="it" v-for="it in user.serialNumber"/>
        </div>
        <br/>
        <br/>
        <div class="d-flex justify-center" style="width: 70%; margin: auto; font-size: 18px; font-weight: bold;">
            <span>儿童姓名</span>
            <p class="d-flex-item" style="flex: 2;"><input class="line" type="text" readonly :value="user.name"/></p>
            <span>性别</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$common.sex.find(e => e.value === user.sex).text"/></p>
            <span>出生日期</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('YYYY')"/></p>
            <span>年</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('MM')"/></p>
            <span>月</span>
            <p class="d-flex-item"><input class="line" type="text" readonly :value="$moment(user.birthday).format('DD')"/></p>
            <span>日</span>
        </div>
        <br/>
        <table border>
            <tr>
                <th colspan="2">项目</th>
                <th class="al-left">{{ data.month }}月龄</th>
            </tr>
            <tr>
                <th width="40" rowspan="2">心理行为发育初筛</th>
                <th width="100">预警征象筛查</th>
                <td >
                    <span class="mask"/>
                    <ul>
                        <li><input type="checkbox" :checked="!data.warningSigns.find(e => e.value === 1) ? true : false"/> 未见异常</li>
                        <li v-for="it in data.warningSigns"><input type="checkbox" :checked="it.value === 1 ? true : false"/> {{ it.name }}</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>语言功能和社会交往能力询问</th>
                <td>
                    <span class="mask"/>
                    <ul>
                        <li><input type="checkbox" :checked="!data.langSocials.find(e => e.value === 1) ? true : false"/> 未见异常</li>
                        <li v-for="it in data.langSocials"><input type="checkbox" :checked="it.value === 1 ? true : false"/> {{ it.name }}</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th colspan="2">初筛结果</th>
                <td>
                    <span class="mask"/>
                    <ul>
                        <li><input type="checkbox" :checked="data.result === 0 ? true : false"/> 未见异常</li>
                        <li><input type="checkbox" :checked="data.result === 1 ? true : false"/> 异常</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th colspan="2">转诊建议</th>
                <td>
                    <div class="d-block">
                        <span class="mask" v-if="data.referral !== ''"/>
                        <ul>
                            <li><input type="checkbox" :checked="data.referralStatus === 0 ? true : false" @click="set_referralStatus(0)"/> 无</li>
                            <li><input type="checkbox" :checked="data.referralStatus === 1 ? true : false" @click="set_referralStatus(1)"/> 有，上转接诊医疗机构名称</li>
                        </ul>
                        <input class="line" type="text" v-model="data.referral" :readonly="!data.referralStatus ? true : false" @input="set_referralText"/>
                    </div>
                </td>
            </tr>
            <tr>
                <th colspan="2">检查日期</th>
                <td>
                    <div class="d-flex mt-xs" style="width: 40%;">
                        <p class="d-flex-item" style="flex: 1.5">
                            <input class="line" type="text" readonly :value="$moment(data.reportTime).format('YYYY')"/>
                        </p>
                        <span>年</span>
                        <p class="d-flex-item">
                            <input class="line" type="text" readonly :value="$moment(data.reportTime).format('MM')"/>
                        </p>
                        <span>月</span>
                        <p class="d-flex-item">
                            <input class="line" type="text" readonly :value="$moment(data.reportTime).format('DD')"/>
                        </p>
                        <span>日</span>
                    </div>
                </td>
            </tr>
            <tr>
                <th colspan="2">医生签名</th>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <th colspan="2">医疗机构名称</th>
                <td>&nbsp;</td>
            </tr>
        </table>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            data: Object,
            user: Object,
        },
        data() {
            return {}
        },
        async beforeDestroy() {},
        async created() {
            console.log('初筛记录表------------->', this.data, this.user);
        },
        async mounted() {},
        methods: {
            async set_referralStatus(data){
                console.log('this.set_referralStatus------------->', data);
                this.data.referralStatus = data;
                if (data === 0){
                    this.data.referral = '';
                }
                await this.$store.commit("initPrintFormData", this.data);
                await this.$forceUpdate();
            },
            async set_referralText(){
                console.log('this.set_referralText------------->', this.data.referral);
                return await this.$store.commit("initPrintFormData", this.data);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/prints/chushai.vue